import React from 'react';
import { Link } from 'react-router-dom';
import './TopBar.css';

const TopBar = () => {
    return (
        <div className="top-bar">
            <div className="top-bar-container">
                <div className="top-bar-links">
                    <Link to="/about">Tentang Kami</Link>
                    <Link to="/how-to-use">Cara Pakai Website</Link>
                </div>
            </div>
        </div>
    );
};

export default TopBar;